import { QueryClient } from "@tanstack/react-query";

import { isResourceHttpError } from "@/utils/getApiErrorStatus";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      throwOnError: (error, query) =>
        query.meta?.resource === true && isResourceHttpError(error),
    },
  },
});
